import { type FC } from "react";
import { IconType } from "../../../../common/components/icon/IconType";
import { useAddProductToWishlistFlow } from "../../../../common/hooks/useAddProductToWishlistFlow";
import { type ProductData } from "../../../../models/ProductData";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

export interface SrpAddToWishlistProps {
  product: ProductData;
  color: "primary" | "secondary";
}

const SrpAddToWishlist: FC<SrpAddToWishlistProps> = ({ product, color }) => {
  const [onClick, modal] = useAddProductToWishlistFlow({ productInput: product });

  const { t } = useTranslation();

  return (
    <>
      <Button
        color={color}
        fullWidth={true}
        startIcon={<DefaultButtonIcon type={IconType.Bookmark} />}
        onClick={() => onClick()}
        data-test-id={"btn-add-to-wishlist"}
      >
        {t("basket.addToWishlist")}
      </Button>
      {modal}
    </>
  );
};

export default SrpAddToWishlist;
